import React from "react";
import { Block, Sub, N, Conv, th, thr, td, tdr } from "./shared";
import { fmtPct } from "../labels";

export function ThemesBlock({ data, drill }) {
  const { rows, words } = data;
  return (
    <Block id="themes" title="Palabras y temas del viajero" subtitle="lo que piden en su mensaje inicial los que compran frente a los que no" defaultOpen={false}>
      <Sub title="Temas detectados en la solicitud" hint="lista cerrada · un lead puede tener varios temas · conversión sobre cerrados">
        <div className="overflow-x-auto">
          <table className="w-full text-[12px]" data-testid="kk-themes-table">
            <thead><tr className="border-b border-clay-300"><th className={th}>Tema</th><th className={thr}>Leads</th><th className={thr}>Vendidos</th><th className={thr}>No vendidos</th><th className={thr}>Conversión</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.key} className="border-b border-clay-100" data-testid={`kk-theme-${r.key}`}>
                  <td className={`${td} font-medium`}>{r.label}</td>
                  <td className={tdr}><N value={r.leads} onClick={() => drill({ theme: r.key })}/></td>
                  <td className={tdr}><N value={r.sold} onClick={() => drill({ theme: r.key, bucket: "sold" })} tone="text-emerald-800"/></td>
                  <td className={tdr}><N value={r.not_sold} onClick={() => drill({ theme: r.key, bucket: "not_sold" })}/></td>
                  <td className={tdr}><Conv value={r.conversion}/></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Sub>
      {(words.sold.length > 0 || words.lost.length > 0) && (
        <div className="grid md:grid-cols-2 gap-6" data-testid="kk-words">
          {[["sold", "Palabras más propias de los que compran", words.sold], ["lost", "Palabras más propias de los que no compran", words.lost]].map(([k, title, list]) => (
            <Sub key={k} title={title} hint="% de solicitudes que la usan: vendidos · no vendidos">
              <div className="flex flex-wrap gap-1.5">
                {list.map((w) => (
                  <span key={w.word} className={`border px-2 py-0.5 text-[11px] ${k === "sold" ? "border-emerald-200 bg-emerald-50" : "border-clay-200 bg-clay-50"}`}>
                    {w.word} <span className="text-clay-500 tabular">{fmtPct(w.sold_pct)} · {fmtPct(w.lost_pct)}</span>
                  </span>
                ))}
              </div>
            </Sub>
          ))}
        </div>
      )}
    </Block>
  );
}
